import { AnyAction } from 'redux';

interface IDirector {
    loading: boolean;
}

const initialState: IDirector = {
    loading: false,
};
export const CreateDirector = (state = initialState, action: AnyAction) => {
    switch (action.type) {
        case 'LOADING_DIRECTOR':
            return {
                ...state,
                loading: action.payload,
            };
        default:
            return state;
    }
};
